// Forgot.js
import React, {useState} from 'react';
import {Alert, Card, Container, Form, Image} from 'react-bootstrap';
import {useNavigate} from 'react-router-dom';
import Logo from '../../assets/solutrak-logo.png';
import '../auth/auth.css';
import './Forgot.css';
import {ReactiveBuilder} from "../../components/Loader/loader";
import axios from "axios";
import NetworkUtils from "../../../utils/NetworkUtils";
import ROUTES from "../../../utils/constants/endpoints";


const Forgot = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const [emailSent, setEmailSent] = useState(false);

    const handleSubmit = async () => {
        setLoading(true);
        setError(null);
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            setError('Email is not a valid email.')

            setLoading(false);
        } else {
            await handlePasswordReset();
            setEmail('');
            setLoading(false);
        }
    };
    const handleLogin = () => {
        navigate(ROUTES.LOGIN, { replace: true });
    }

    const handleErrorDialogDismiss = () => {
        setError(null);
    }

    const handlePasswordReset = async () => {
        try {
            const { data } = await axios.get(
                `https://services.solucore.com/solutrak/api/accounts/forgotPassword?email=${email}`
            );

            if (data.IsSuccess) {
                setEmailSent(true);
                console.log(data.Message);
                setError(null);
            } else {
                setError(data.Message);
            }
        } catch (error) {
            NetworkUtils.handleAxiosError(error, setError);
        }
    };

    return (
        <Container fluid className="auth-container d-flex align-items-center justify-content-center">
            <Card className="auth-card vw-25 vh-50 px-0 py-0">
                <div className="logo-title-container d-flex justify-content-center pt-5">
                    <Image className="logo-big" src={Logo} alt="Logo"/>
                </div>
                <Card.Body className='mx-5'>
                    {error ? (<Alert variant="danger" dismissible={true} onClose={handleErrorDialogDismiss}>{error}</Alert>) : (<div>
                        <h4 className={`auth-title text-center mb-3 fw-light fs-4 ${emailSent ? 'mt-5' : ''}`} style={{color: 'white'}}>
                            {emailSent ? 'Almost done' : 'Forgot Password'}
                        </h4>
                        <div className='auth-subtitle text-center w-100'>
                            <div className='py-0 text-center text-wrap fw-light'
                                 style={{wordWrap: 'break-word'}}>
                                <p>
                                    {emailSent ? (
                                        <>
                                            You will be able to reset your password by hitting the link sent via
                                            email
                                        </>
                                    ) : (
                                        <>
                                            We can help you reset your password using the email address associated
                                            with your account.
                                        </>
                                    )}
                                </p>
                            </div>
                        </div>
                    </div>)}

                    {emailSent ? (<div className="text-center my-3">
                        <button type="button" className="auth-button mb-5 mt-4" onClick={handleLogin}>
                            Go to Login
                        </button>
                    </div>) : (<Form className="auth-form-container my-4" onSubmit={(e) => {
                        e.preventDefault(); // Prevent default form submission
                        handleSubmit();
                    }}>
                        <Form.Group className="py-0 w-100">
                            <Form.Control
                                type="text"
                                placeholder="Email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className={`auth-input ${error ? 'border-danger mb-1' : 'mb-3'}`}
                                style={{
                                    borderColor: error ? 'red' : '',
                                }}
                            />
                            <ReactiveBuilder loading={loading}>
                                <div className="text-center my-2">
                                    <button type="submit" className="auth-button">
                                        Reset password
                                    </button>
                                </div>
                            </ReactiveBuilder>
                        </Form.Group>
                    </Form>)}
                </Card.Body>
                {!emailSent && (
                    <Card.Footer className='text-primary w-100'>
                        <div onClick={handleLogin} className="card-footer-text">
                            Login
                        </div>
                    </Card.Footer>
                )}
            </Card>
        </Container>


    );
};

export default Forgot;
